import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the TableOwnersIncomeSecondLevelReports view.
 */
export default class TableOwnersIncomeSecondLevelReports extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a value as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: 'datatable', // ID for the datatable
                            view: 'datatable', // Datatable view
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [
                                // Column definitions for the datatable
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 200,
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'UniqueTransactionId',
                                    header: _('Identificador único de la transacción'),
                                    width: 250,
                                },
                                {
                                    id: 'PlayerId',
                                    header: _('Identificador único del jugador'),
                                    width: 250,
                                },
                                {
                                    id: 'PlayerName',
                                    header: _("Nombre del jugador"),
                                    width: 350,
                                },
                                {
                                    id: 'DocumentType',
                                    header: _('Tipo de documento'),
                                    width: 200,
                                },
                                {
                                    id: 'DocumentNumber',
                                    header: _('Numero de documento'),
                                    width: 250,
                                },
                                {
                                    id: 'SportName',
                                    header: _('Nombre del deporte'),
                                    width: 250,
                                },
                                {
                                    id: 'CompetitionName',
                                    header: _('Nombre de la competencia'),
                                    width: 250,
                                },
                                {
                                    id: 'EventName',
                                    header: _('Nombre del evento'),
                                    width: 250,
                                },
                                {
                                    id: 'MarketName',
                                    header: _('Nombre del mercado'),
                                    width: 200,
                                },
                                {
                                    id: 'Selection',
                                    header: _('Selección'),
                                    width: 200,
                                },
                                {
                                    id: 'Bet',
                                    header: _('Apuesta'),
                                    width: 300,
                                },
                                {
                                    id: 'Award',
                                    header: _('Premio'),
                                    width: 300,
                                },
                                {
                                    id: 'Odds',
                                    header: _('Cuota'),
                                    width: 150,
                                },
                                {
                                    id: 'TicketDate',
                                    header: _('Fecha de ticket'),
                                    width: 250,
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Custom date format
                                },
                                {
                                    id: 'StartDate',
                                    header: _('Fecha de inicio'),
                                    width: 250,
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Custom date format
                                },
                                {
                                    id: 'EndDate',
                                    header: _('Fecha de fin'),
                                    width: 250,
                                    format: webix.Date.dateToStr('%d/%m/%Y %H:%i:%s'), // Custom date format
                                },
                            ],
                            on: {
                                // Event handlers for the datatable
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay after data load
                                },
                            },
                            ready: function () {
                                if (!this.count()) {
                                    // Check if there are no data
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    ); // Show no data overlay
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable math operations
                            datafetch: 10, // Number of records to fetch at a time
                            pager: 'pagerA', // ID of the pager component
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the datatable instance
        let url = devConfig.geturlApi() + 'es/Financial/GetIncomeSecondLevel'; // API endpoint URL

        // Event listener for filtering data
        this.on(this.app, 'ownersIncomeSecondLevel:filter', (filterData) => {
            let object = Object.entries(filterData); // Convert filter data to entries
            let string1 = ''; // Query string for filters

            for (let i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        let date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Sort' && object[i][0] != 'Dir' && object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        } else {
                            if (object[i][0] == 'Date') {
                                let date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        let object2 = Object.entries(object[i][1]); // Convert nested filter data to entries
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    let d = new Date(object2[j][1]); // Create date object from start
                                    let dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format start date
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        let d = new Date(object2[j][1]); // Create date object from end
                                        let dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format end date
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$('consultDesk').define('disabled', true); // Disable consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1) // Load data with filters
                .then((response) => {
                    $$('consultDesk').define('disabled', false); // Enable consult desk after loading
                })
                .catch((e) => {
                    $$('consultDesk').define('disabled', false); // Enable consult desk on error
                });
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Event listener for page change in the pager
        $$('pagerA').attachEvent('onAfterPageChange', function (page) {
            webix.delay(
                function () {
                    if (page != '0') {
                        chargeTable(); // Load data for the new page
                    }
                },
                '',
                '',
                100,
            );
        });

        // Event listener for changing size
        this.on(this.app, 'changeSize', (filterData) => {
            chargeTable(); // Load data on size change
        });

        /**
         * Loads data for the datatable based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get page size
            let page = grid.getPage(); // Get current page
            let first = size * page; // Calculate first record index
            let last = first + size - 1; // Calculate last record index
            grid.load(url + '?start=' + first + '&count=' + (last + 1) + filter); // Load data with pagination
        }
    }
}

// FILE DOCUMENTED
